import axios from "axios";
import { useEffect, useState } from "react";
import Select, { components } from "react-select";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";
import { assetTypes, clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import StaticUtils from "../../utils/StaticUtils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const CateSubCatSelectionComp = (props) => {
  const {
    selectedCategory,
    setSelectedCategory,
    selectedSubcategory,
    setSelectedSubcategory,
    selectedContentType,
    setSelectedContentType,
    showSubCate,
    showContentType = false,
    showCategory,
  } = props;
  const authBroker = useSelector((state) => state.auth.authBroker);

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [contentTypeOptions, setContentTypeOptions] = useState([]);
  const { t } = useTranslation();
  const handleChangeContentType = (selected) => {
    clickStreamUser("content_type_filter_selected", {
      userId: authBroker?.payload?.user?.user_id,
      seletedContentType: selected,
    });
    console.log("selected content type", selected);
    setSelectedContentType(selected);
  };

  const handleChangeSubCat = (selected) => {
    setSelectedSubcategory(selected);
  };
  const handleChange = (selected) => {
    clickStreamUser("category_filter_selected", {
      userId: authBroker?.payload?.user?.user_id,
      seletedCategory: selected,
    });
    setSelectedCategory(selected);
  };

  useEffect(() => {
    getCategoryList();
    getSubCategoryList();

    let contentTypeList = _.cloneDeep(assetTypes);
    contentTypeList = _.sortBy(contentTypeList, "name");
    const mappedOptions = contentTypeList.map((cat) => ({
      value: cat.id,
      label: cat.name,
    }));
    setContentTypeOptions(mappedOptions);
  }, []);
  const getCategoryList = async () => {
    try {
      const url = `${CONFIG.API_URL_REAL_BROKER}${API_LIST.BROKER_API.GET_CATEGORY_LIST_NEW_END_POINT1}`;
      const payload = {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      };
      const res = await axios.post(url, payload);
      if (res.data?.data) {
        const mappedOptions = res.data?.data.map((cat) => ({
          value: cat.term_id,
          label: StaticUtils.decodeHtml(cat.name),
        }));
        setCategoryOptions(mappedOptions);
      }
    } catch (error) {
      console.error("error while getting category data", error);
    } finally {
    }
  };
  const getSubCategoryList = async () => {
    try {
      const url = `${CONFIG.API_URL_REAL_BROKER}${API_LIST.BROKER_API.GET_SUB_CATEGORY_LIST_NEW_END_POINT}`;
      const payload = {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      };
      const res = await axios.post(url, payload);
      if (res.data?.data) {
        const mappedOptions = res.data?.data.map((cat) => ({
          value: cat.term_id,
          label: StaticUtils.decodeHtml(cat.name),
        }));
        setSubCategoryOptions(mappedOptions);
      }
    } catch (error) {
      console.error("error while getting category data", error);
    } finally {
    }
  };

  const CustomValueContainer = ({ children, ...props }) => {
    const selectedOptions = props.getValue();

    if (!selectedOptions.length)
      return (
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      );

    const displayLabel = selectedOptions[0].label;
    const count = selectedOptions.length - 1;

    return (
      <components.ValueContainer {...props}>
        {`${displayLabel}${count > 0 ? ` +${count}` : ""}`}
      </components.ValueContainer>
    );
  };
  const CustomOption = (props) => {
    const { data, isSelected, innerRef, innerProps } = props;

    return (
      <div ref={innerRef} {...innerProps}>
        <input
          type="checkbox"
          checked={isSelected}
          readOnly
          // style={{ marginRight: 8 }}
        />
        <label>{data.label}</label>
      </div>
    );
  };
  const customStyles = {
    control: (base) => ({
      ...base,
      width: 300, // or '100%'
    }),
    menu: (base) => ({
      ...base,
      width: 300,
    }),
  };
  return (
    <>
      <div className="filters">
        <label>{t("filter_by")}</label>
        {showCategory && (
          <Select
            isMulti
            options={categoryOptions}
            styles={customStyles}
            value={selectedCategory}
            onChange={handleChange}
            placeholder={t("select_category")}
            className="my-custom-select" // wrapper class
            classNamePrefix="custom" // prefix for inner class names
            // closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              ValueContainer: CustomValueContainer,
              Option: CustomOption,
            }}
          />
        )}
        {showSubCate && (
          <Select
            isMulti
            options={subCategoryOptions}
            value={selectedSubcategory}
            onChange={handleChangeSubCat}
            styles={customStyles}
            className="my-custom-select" // wrapper class
            classNamePrefix="custom" // prefix for inner class names
            placeholder={t("select_subcategory")}
            hideSelectedOptions={false}
            components={{
              ValueContainer: CustomValueContainer,
              Option: CustomOption,
            }}
          />
        )}

        {showContentType && (
          <Select
            isMulti
            options={contentTypeOptions}
            value={selectedContentType}
            styles={customStyles}
            onChange={handleChangeContentType}
            className="my-custom-select"
            classNamePrefix="custom"
            placeholder={t("select_content_type")}
            hideSelectedOptions={false}
            components={{
              ValueContainer: CustomValueContainer,
              Option: CustomOption,
            }}
          />
        )}
      </div>
    </>
  );
};

export default CateSubCatSelectionComp;
